// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#00c8b4","colorSecondary":"#82e682","colorBlack":"#0a5064","colorGreyLight":"#e9f0f3","colorGreyMedium":"#6c7784","colorAlert":"#990063"};